<template lang="pug">

tr(v-bind:class='status')

    //- Status
    //- td.center.aligned
    //-     i.colored.green.dot.circle.outline.icon(v-tooltip='"Aktiv"' v-show='companyModel.status === "HAS_ACCESS"')
    //-     i.colored.red.ban.icon(v-tooltip='"Inaktiv"' v-show='companyModel.status === "HAS_NO_ACCESS"')

    //- Name
    td: router-link(v-bind:to='{ name: "companies/update", params: { id: companyModel.id }}') {{ companyModel.name }}

    //- Typen
    td {{ types }}

    //- Stadt
    td {{ city }}

    //- Actions
    td.right.aligned

        //- Unternehmen verwalten
        router-link.ui.small.basic.icon.button(
            v-bind:to='{ name: "companies/update", params: { id: companyModel.id } }'
            v-tooltip='"Unternehmen verwalten"'
        )
            i.building.outline.icon

        //- Adressen verwalten
        router-link.ui.small.basic.icon.button(
            v-bind:to='{ name: "addresses", query: { company: companyModel.id } }'
            v-tooltip='"Adressen verwalten"'
        )
            i.address.book.outline.icon

        //- Benutzer verwalten
        router-link.ui.small.basic.icon.button(
            v-bind:to='{ name: "users", query: { company: companyModel.id } }'
            v-tooltip='"Benutzer verwalten"'
        )
            i.user.outline.icon

</template>

<script>
    import compose from 'lodash/fp/compose'
    import property from 'lodash/fp/property'
    import { find_by_id as find_address_by_id } from '@/utils/address'

    //noinspection JSUnusedGlobalSymbols
    export default {
        computed: {
            city() {
                return compose(

                    // Stadt lesen
                    property('city'),

                    // Adresse holen
                    find_address_by_id(this.addressModels),

                    // ID der Standard-Rechnungsadresse holen
                    property('defaultBillingAddress')

                )(this.companyModel)
            },

            status() {
                return {
                    'green marked left': this.companyModel.status === 'HAS_ACCESS',
                    'red marked left': this.companyModel.status === 'HAS_NO_ACCESS',
                    'orange colored': this.companyModel.isPrepayment === true
                }
            },

            types() {
                const types = []

                if (this.companyModel.isAgency) {
                    types.push('Agentur')
                }

                if (this.companyModel.isSupplier) {
                    types.push('Lieferant')
                }

                if (this.companyModel.isPurchaser) {
                    types.push('Auftraggeber')
                }

                return types.join(', ')
            }

        },

        props: {
            addressModels: {
                type: Array,
                required: true
            },
            companyModel: {
                type: Object,
                required: true
            }
        }

    }

</script>
